import dayjs from "dayjs";
import advancedFormat from 'dayjs/plugin/advancedFormat'
import utc from "dayjs/plugin/utc";

import { ScheduleDataType, Shift, ShiftOption } from "./types";

dayjs.extend(utc);
dayjs.extend(advancedFormat)

export const handleShiftChange =
(_: React.SyntheticEvent,
  newValue: ShiftOption | null,
  reportDate: string,
  setSelectedShift: React.Dispatch<React.SetStateAction<string | null>>,
  setScheduleData: React.Dispatch<React.SetStateAction<ScheduleDataType>>
) => {
  if (!newValue) return;

  setSelectedShift(newValue.id);

  if (newValue.id === 'custom') return;

  setScheduleData(prev => ({
    ...prev,
    startTime: dayjs(new Date(reportDate as string).setHours(
      parseInt(newValue.startTime.split(':')[0]),
      parseInt(newValue.startTime.split(':')[1])
    )),
    endTime: dayjs(new Date(reportDate as string).setHours(
      parseInt(newValue.endTime.split(':')[0]),
      parseInt(newValue.endTime.split(':')[1])
    ))
  }));
};

export const getShiftOptions = (availableShifts: Shift[]) => [
  ...availableShifts.map((shift: Shift, index: number) => ({
    id: `shift-${index}`,
    label: `${shift.name} (${shift.startTime} - ${shift.endTime})`,
    startTime: shift.startTime,
    endTime: shift.endTime
  })),
  {
    id: 'custom',
    label: 'Custom Shift',
    startTime: '',
    endTime: ''
  }
];
